export const SPECIALIZATIONS = {
  NONE: null,
  PEDIATRICS: 'pediatrics',
}
